
import { Renderer }  from 'pixi.js'
//import { Assets, Sprite } from './lib/pixi.mjs';
//import { Application,Renderer, Sprite, SCALE_MODES } from  '../../lib/pixi.mjs';
//import SceneManager from './SceneManager.js'
//import GameScene from './Scenes/GameScene.js'
export default class GameEngineUI {
    constructor(width, height, options, parentElement) {
        this.stageWidth = width;
        this.stageHeight = height;
        this.devicePixelRatio = window.devicePixelRatio || 1;
        this.scene = null;
        this.isLoaded = false;
        this.isDestroyed = false;
        this.options = options || {};
        this.onError = null;
        this.parentElement = parentElement || "Game";
        this.resizeEventListener = this.resize.bind(this);
        this.options.hello = true;

        //PIXI.settings.PREFER_ENV = PIXI.ENV.WEBGL1;

        //note: for canvas https://www.npmjs.com/package/pixi.js-legacy is needed
        ////if (useCanvas) this.renderer = new CanvasRenderer(options);
        //if (useCanvas) this.renderer = new PIXI.Renderer(options);
        //else  this.renderer = PIXI.autoDetectRenderer(options);
        
        this.renderer = new Renderer(options);
        if (!this.renderer.view.parentElement && document.getElementById(this.parentElement)) {
            document.getElementById(this.parentElement).appendChild(this.renderer.view);
        }
       

        //this.onWebglcontextlostEventListener = this.webglcontextlost.bind(this);
        //this.renderer.view.addEventListener("webglcontextlost", this.onWebglcontextlostEventListener);
        this.renderLoop();
        this.resize();

        window.addEventListener("resize", this.resizeEventListener);
    }
    // load(options,scene){
    //     if(!options) options = this.options;
    //     if(!scene) scene = this.startScene;


    //     return this.loadScene(scene);
    // }
    webglcontextlost() {
        if (this.renderer && this.renderer.view) {
            this.renderer.view.removeEventListener("webglcontextlost", this.onWebglcontextlostEventListener);
        }
        if (this.onError) {
            this.onError("webglcontextlost");
        }
    }

    async loadScene(scene) {
        await scene.preload();
        this.scene = scene; 
        scene.update();
        this.resize();
    }
    resize() {
        //resize canvas
        //return;
        if (!this.renderer) return;

        //option 1 fill full parent container
        if (this.renderer.view && this.renderer.view.parentElement) {
            this.renderer.resize(this.renderer.view.parentElement.clientWidth, this.renderer.view.parentElement.clientHeight);
        }
        //option 2 fill full window/screen and pixijs does it own background using autoResize:  true
        //this.renderer.resize(this.renderer.view, window.innerHeight);
        //option 3 resizeScaleToFit rather then fill and let html fill in the letterboxing


        //note:could iterate through the object and apply scaling/sretching rather than explictly asigning
        //note: could update a viewPort size up the tree
        //note: could send event on resize up the tree, for now just use a fixed size that is resized here

        // //resize background
        // //note: can't stretch wappercontainer as it will stretch stagecontainer
        // this.resizeStretch(this.background, this.renderer.width, this.renderer.height);

        //resize scalear
        if (this.scene && this.scene.stage)
            this.resizeScaleToFit(this.scene.stage, this.renderer.width / this.renderer.resolution, this.renderer.height / this.renderer.resolution, this.stageWidth, this.stageHeight);

        this.render(true);
    }
    resizeStretch(container, width, height) {
        container.width = this.renderer.width;
        container.height = this.renderer.height;
    }
    //todo: create Scaler container class
    resizeScaleToFit(container, wrapperWidth, wrapperHeight, innerwidth, innerheight) {
        //center stage and reszie
        let ratio = Math.min(wrapperWidth / innerwidth, wrapperHeight / innerheight);
        container.scale.set(ratio, ratio);
        //container.position.set((wrapperWidth) / 2, (wrapperHeight) / 2); //center align
        //container.pivot.set(innerwidth / 2, innerheight / 2); //center align
        //container.position.set((wrapperWidth) / 2, 0); //top align
        //container.pivot.set(innerwidth / 2, 0);//top align
        container.position.set((wrapperWidth) / 2, (wrapperHeight)); //bottom align
        container.pivot.set(innerwidth / 2, innerheight);//bottom align
    }
    renderLoop() {
        if (this.isDestroyed) return;
        this.update();
        this.render();
        window.requestAnimationFrame(this.renderLoop.bind(this));
    }
    update() {
        var scene = this.scene;
        if (scene) {
            if (scene.update)
                scene.update();
        }
    }
    render(override) {
        // //note: current = poll for dirty
        // //note: could only call next render if isDirty = true.  If not then wait until renderer gets kicked off again by game logic

        // //only render if objects have changed
        // //let isDirty = this.checkIfDirty(this.stage);
        // //if (override === true || isDirty===true) {
        //var stage = this.stage;//this.state.current
        // var scene = this.state.current || this.stage;
        var scene = this.scene;
        if (scene && scene.stage) {

            if (override === true || scene.isDirty === true) {
                this.renderer.render(scene.stage);
                if (scene.render)
                    scene.render(this.renderer);
            }
        }
        // //this.renderer.render(this.stage);
        // //}

        //var stage = this.stage;
        //this.renderer.render(stage);

        // window.requestAnimationFrame(this.render.bind(this));
    }
    checkIfDirty(container, isDirty) {

        if (container.isDirty === true) isDirty = true;
        container.isDirty = false;

        let children = container.children;
        for (let i = 0; i < children.length; i++) {
            let child = children[i];
            let isDirtyChild = this.checkIfDirty(child);
            if (isDirtyChild === true) isDirty = true;
        }
        return isDirty;
    }
    destroy() {
        this.isDestroyed = true;
        window.removeEventListener("resize", this.resizeEventListener);
        if (this.renderer && this.renderer.view) {
            this.renderer.view.removeEventListener("webglcontextlost", this.onWebglcontextlostEventListener);
        }
        if (this.scene && this.scene.destroy) {
            this.scene.destroy();
            this.scene = null;
            //todo: destroy all scenes if there are more than one
        }
        if (this.renderer) {
            this.renderer.destroy(true);
            this.renderer = null;
        }
    }
    androidV(ua) {
        ua = (ua || navigator.userAgent).toLowerCase();
        var match = ua.match(/android\s+([\d\.]+)/i);
        return parseFloat(match ? match[1] : undefined);
    };
    getOS() {
        let os = null;
        var ua = navigator.userAgent;
        var isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFS‌​AW|KFSOWI|KFTBW|KFTH‌​W|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(ua);
        if (/(android)/i.test(navigator.userAgent) && isKindle) {
            os = "amazon";
        }
        else if (/(android)/i.test(navigator.userAgent) && !isKindle) {
            os = "android";
        }
        else if (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel') {
            os = "ios";
        }
        else if (/(windows phone)/i.test(navigator.userAgent)) {
            os = "windows";
        }
        else if (/(windows)/i.test(navigator.userAgent)) {
            os = "windows";
        }
        return os;
    }
}